import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'
import vueConfig from '@/../vue.config'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/routes/Home')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/routes/Login'),
        props: true
    },
    {
        path: '/assignments',
        name: 'Assignments',
        component: () => import('@/routes/Assignment')
    },
    {
        path: '/assignments/:mode',
        name: 'Assignments Create Form',
        component: () => import('@/forms/AssignmentForm')
    },
    {
        path: '/assignments/:assignmentId/:mode/',
        name: 'Assignments Edit Form',
        component: () => import('@/forms/AssignmentForm')
    },
    {
        path: '/my-profile',
        name: 'MyProfile',
        component: () => import('@/routes/MyProfile')
    },
    {
        path: '/users',
        name: 'User',
        component: () => import('@/routes/User'),
        meta: ['ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_CONTRACTOR']
    },
    {
        path: '/stats',
        name: 'Statistics',
        component: () => import('@/routes/Stats')
    },
    {
        path: '/calendar',
        name: 'Calendar',
        component: () => import('@/routes/Calendar')
    },
    {
        path: '/cabins',
        name: 'Cabins',
        component: () => import('@/routes/Cabins')
    },
    {
        path: '/storage',
        name: 'Storage',
        component: () => import('@/routes/Storage')
    },
    {
        path: '/material/:materialId',
        name: 'Material',
        component: () => import('@/routes/Material')
    },
    {
        path: '/imports',
        name: 'Import',
        component: () => import('@/routes/Import'),
        meta: ['ROLE_ADMIN', 'ROLE_COORDINATOR']
    },
    {
        path: '/exports',
        name: 'Export',
        component: () => import('@/routes/Export')
    },
    {
        path: '/colors',
        name: 'Colors',
        component: () => import('@/routes/Color')
    },
    {
        path: '/create-user',
        name: 'Create User',
        component: () => import('@/forms/UserForm'),
        meta: ['ROLE_ADMIN']
    },
    {
        path: '/edit-user/:userId',
        name: 'User Edit',
        component: () => import('@/forms/UserForm'),
        meta: ['ROLE_ADMIN']
    }
]

const router = new VueRouter({
    mode: 'history',
    base: vueConfig.publicPath,
    routes
})
const containsAny = (arr1, arr2) => {
    return arr1.some(item => arr2.includes(item))
}

router.beforeEach((to, from, next) => {
    const token = store.getters.getToken
    const userRoles = jwtUtil.getRoles(token)
    const hasCabins = store.getters.getConfig && store.getters.getConfig.hasCabins
    const hasCalendar = store.getters.getConfig && store.getters.getConfig.hasCalendar
    const hasStorage = store.getters.getConfig && store.getters.getConfig.hasStorage
    if ((!token || (token && jwtUtil.isJwtExpired(token))) && to.name !== 'Login') {
        store.dispatch('logout').then(() => next({ path: '/login' }))
    } else if ((token && !jwtUtil.isJwtExpired(token) && to.name === 'Login') ||
            ((to.name === 'Material' || to.name === 'Storage') && !hasStorage) ||
            (to.name === 'Calendar' && !hasCalendar) ||
            (to.name === 'Cabins' && !hasCabins)) {
        next({ path: '/' })
    } else if ((!token && to.name === 'Login') || (!to.meta || Object.keys(to.meta).length === 0 || (Array.isArray(to.meta) && containsAny(to.meta, userRoles)))) {
        next()
    }
})

export default router
